export const CHANGE_HOME_NAV = 'CHANGE_HOME_NAV'
export const CHANGE_PROFILE_NAV = 'CHANGE_PROFILE_NAV'
export const CHANGE_NOTIFICATIONS_NAV = 'CHANGE_NOTIFICATIONS_NAV'
export const CHANGE_NAVIGATION_STATE = 'CHANGE_NAVIGATION_STATE'



// WEBPACK FOOTER //
// ./src/store/actions/navigationChange.js